"use client";

import { useEffect } from "react";
import { useUserStore } from "@/stores/userStore";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface ModalViewUserProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string | null;
}

export default function ModalViewUser({
  isOpen,
  onClose,
  userId,
}: ModalViewUserProps) {
  const { selectedUser, isLoadingDetail, fetchUserById, clearSelectedUser } =
    useUserStore();

  useEffect(() => {
    if (isOpen && userId) {
      fetchUserById(userId);
    }
    return () => {
      clearSelectedUser();
    };
  }, [isOpen, userId, fetchUserById, clearSelectedUser]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-gray-900 dark:text-white">
            Chi tiết người dùng
          </DialogTitle>
        </DialogHeader>

        {isLoadingDetail ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600 dark:text-gray-400">
              Đang tải...
            </span>
          </div>
        ) : !selectedUser ? (
          <div className="p-6 text-center text-gray-600 dark:text-gray-400">
            Không tìm thấy người dùng
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">
                Họ và tên
              </div>
              <div className="text-base font-medium text-gray-900 dark:text-white">
                {selectedUser.name}
              </div>
            </div>
            <div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">
                Tên đăng nhập
              </div>
              <div className="text-base font-medium text-gray-900 dark:text-white">
                {selectedUser.username}
              </div>
            </div>
            <div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">
                Email
              </div>
              <div className="text-base font-medium text-gray-900 dark:text-white">
                {selectedUser.email || "-"}
              </div>
            </div>
            <div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">
                Vai trò
              </div>
              <Badge
                variant="secondary"
                className="bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300"
              >
                {typeof selectedUser.role === "object"
                  ? selectedUser.role?.name
                  : selectedUser.role}
              </Badge>
            </div>
          </div>
        )}

        <div className="flex justify-end">
          <Button variant="outline" onClick={onClose}>
            Đóng
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
